import responseMsg from "@/locales/responseMsg.locale.json";

const enMessages = responseMsg.en || {};

// EN may keep {{_count_}} to match backend; vue-i18n 8 escapes {{ to {, so $t can leave {_count_}.
function normalizePlaceholders(template) {
  if (!template) {
    return template;
  }
  let index = 0;
  return template
    .replace(/\{\{_count_\}\}/g, () => `{${index++}}`)
    .replace(/\{_count_\}/g, () => `{${index++}}`);
}

function extractPlaceholderValues(template, formatted) {
  const normalized = normalizePlaceholders(template);
  if (!normalized || !/\{\d+\}/.test(normalized)) {
    return [];
  }

  const parts = normalized.split(/\{\d+\}/);
  let rest = formatted;
  const values = [];

  for (let i = 0; i < parts.length - 1; i++) {
    const literal = parts[i];
    if (literal) {
      if (!rest.startsWith(literal)) {
        return null;
      }
      rest = rest.slice(literal.length);
    }

    const next = parts[i + 1];
    if (next) {
      const end = rest.indexOf(next);
      if (end < 0) {
        return null;
      }
      values.push(rest.slice(0, end));
      rest = rest.slice(end);
    } else {
      values.push(rest);
      rest = "";
    }
  }

  const last = parts[parts.length - 1];
  if (last && rest !== last) {
    return null;
  }
  return values;
}

function fillTemplate(template, values) {
  let filled = normalizePlaceholders(template);
  if (!values.length) {
    return filled;
  }
  values.forEach((value, index) => {
    filled = filled.split(`{${index}}`).join(String(value));
  });
  return filled;
}

function coerceErrorRaw(raw) {
  if (typeof raw === "string") {
    return raw;
  }
  if (raw == null) {
    return "";
  }
  if (typeof raw !== "object") {
    return String(raw);
  }
  const candidates = [raw.message, raw.Message, raw.error, raw.Error, raw.title, raw.Title];
  for (let i = 0; i < candidates.length; i++) {
    if (typeof candidates[i] === "string" && candidates[i]) {
      return candidates[i];
    }
  }
  try {
    return JSON.stringify(raw);
  } catch (e) {
    return "";
  }
}

export function translateResponseError(vm, raw) {
  const text = coerceErrorRaw(raw);
  if (!text) {
    return "";
  }

  const colonIndex = text.indexOf(":");
  const errorCode = (colonIndex < 0 ? text : text.slice(0, colonIndex)).trim();
  const backendBody = colonIndex < 0 ? "" : text.slice(colonIndex + 1).trim();

  if (errorCode === "invalid captcha") {
    return vm.$t(errorCode);
  }

  const template = enMessages[errorCode];
  if (!template) {
    return text;
  }

  const values = extractPlaceholderValues(template, backendBody);
  if (values === null) {
    return text;
  }

  // $t without values returns the locale template (keeps {0} / {{_count_}})
  const localeTemplate = vm.$te && vm.$te(errorCode) ? vm.$t(errorCode) : template;
  const translated = fillTemplate(localeTemplate, values);
  if (/\{\d+\}/.test(translated) || /\{\{/.test(translated) || /\{_count_\}/.test(translated)) {
    return text;
  }
  return errorCode + ": " + translated;
}
